module.exports = __webpack_public_path__ + "static/media/icon-side-hustle.5326363c.svg";